import { AxiosResponse } from 'axios'
import { privateApi } from 'api'
import {
  ILogisticsSettings,
  IUpdateLogisticsSettings
} from 'models/logisticsSettings'
import {
  IDeliveryCalculationRequest,
  IDeliveryCalculationResponse
} from 'models/deliveryCalculator'

export const logisticsSettingsApi = {
  getSettings: (): Promise<AxiosResponse<ILogisticsSettings>> => {
    return privateApi.get('/admin/logistics-settings')
  },
  updateSettings: (
    data: IUpdateLogisticsSettings
  ): Promise<AxiosResponse<ILogisticsSettings>> => {
    return privateApi.patch('/admin/logistics-settings', data)
  },
  calculateDelivery: (
    data: IDeliveryCalculationRequest
  ): Promise<AxiosResponse<IDeliveryCalculationResponse>> => {
    return privateApi.post(
      '/admin/logistics-settings/calculate-delivery',
      data
    )
  }
}
